import React from 'react';
import {PROPERTIES} from "../../consts/tables";
import Alert from "../Alert";
import {manageData} from "../../requests/CRUD";
import PropertyForm from '../PropertyForm/PropertyForm';
import { priceToString } from '../CRUDProperty/CRUDProperty';
import { sendOffMarketSellerEmail } from '../../requests/emailRequests';
import { url } from '../../consts/env';
import {formatAddress} from "../../utils";

const priceProps = [
    'LIST_PRICE',
];

function convertFormToData(formData) {
    const data = {...formData};
    
    priceProps.forEach((key) => {
        const num = priceToString(data[key]);
        if (num !== false)
            data[key] = num;
    });
    return data;
}

export default class PropertyDrawer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {},
            paneIndex: 0,
            isBusy: null,
            error: null,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.saveData = this.saveData.bind(this);
    }

    componentDidMount() {
        const data = {...this.state.data};
        data.TRANSACTION_TYPE = 'Investment Sales';
        data.SOURCE = 'SUMMIT';
        this.setState({data});
    }

    componentDidUpdate(prevProps){
        if(prevProps.resetDrawer !== this.props.resetDrawer && this.props.resetDrawer === true)
            this.setState({data:{TRANSACTION_TYPE:'Investment Sales',SOURCE:'SUMMIT'}});
    }

    handleSubmit(e) {
        e.preventDefault();
        this.saveData();
    }

    handleChange(key, value) {
        const data = {...this.state.data};
        data[key] = value;
        this.setState({data});
    }

    handleDropdownChange(query, queryType, x, key) {
        if(key === 'LISTING_AGENT_1')
            query.LISTING_AGENT_1_PERCENT = '100';
        this.setState({data:query});
    }

    saveData() {
        if (this.state.isBusy) return;

        this.setState({
            isBusy: true,
            error: null,
        });

        Object.keys(this.state.data).forEach(k => {
            if (!this.state.data[k] || k === 'undefined') {
                const newData = {...this.state.data};
                delete newData[k];
                this.setState({data: newData})
            }
        });

        const data = this.state.data;
        const sellerId = this.props.sellerId;
        let userName = this.props.userData.person.firstName + ' ' + this.props.userData.person.lastName;
       
        if(this.props.isOffMarket)
            data.STATUS = 'Off Market';

        data.CREATED_BY = userName;
        data.DATE_CREATED = new Date().toISOString().split("T")[0];
        data.LAST_MODIFIED_BY = userName;
        data.LAST_MODIFIED_DATE = new Date().toISOString().split("T")[0];
        data.SELLER_ID = sellerId;
        data.ADDRESS = formatAddress(data.ADDRESS);

        Promise.all([
            manageData({
                tableCode: PROPERTIES,
                data: [convertFormToData(data)],
            })
        ]).then(res => {
            if (res && res[0] && res[0].success) {
                this.setState({isBusy: false});
                this.props.savedNewItem(res[0].data[0]);

                if(res[0].data[0].STATUS === 'Off Market'){
                    const link = `${url}list?NAME=${res[0].data[0].NAME}&SOURCE=${res[0].data[0].SOURCE}&ADDRESS=${res[0].data[0].ADDRESS}&STATUS=${res[0].data[0].STATUS}&TRANSACTION_TYPE=${res[0].data[0].TRANSACTION_TYPE}`;
                    const property = {
                        ...res[0].data[0],
                        LINK:link
                    }
                    sendOffMarketSellerEmail(property);
                }
                if (this.props.closeDrawer) {
                    this.props.closeDrawer();
                    setTimeout(() => this.setState({data: {}}));
                }
            } else {
                this.setState({
                    isBusy: null,
                    error: res && res[0] && res[0].message ? res[0].message : 'Unspecified error',
                });
            }
        });
    }

    render() {
        const data = this.state.data;

        return (
            <div>
                <PropertyForm data={data}
                           paneIndex={this.state.paneIndex}
                           handleSubmit={this.handleSubmit}
                           handleCancel={this.props.closeDrawer}
                           handleParentChange={this.handleChange}
                           handleParentDropdownChange={this.handleDropdownChange}/>
                {this.state.error && <Alert type='error'>{this.state.error}</Alert>}
            </div>
        )
    }
}